import { AbstractControl } from '@angular/forms';
import { DateInputEnum } from '../models/date-input.enum';


export function customMaskedDateValidator(inputType: DateInputEnum) {
    let letterGroup = '';
        switch (inputType) {
            case DateInputEnum.TIME:
                letterGroup = '[hms]';
                break;
            case DateInputEnum.DATE:
                letterGroup = '[dMy]';
                break;
            case DateInputEnum.DATE_TIME:
            default:
                letterGroup = '[hmsdMy]';
                break;
        }
    return (formControl: AbstractControl): { [message: string]: boolean } => {
        let output = null;
        const regExp = new RegExp(letterGroup); 
        const splittedValue = formControl.value.split("");
        if (splittedValue.length  < 1) {
            return { placeholder_error: true };
        } 
        splittedValue.forEach(i => {
            if (regExp.test(i) === true) {
                output = { placeholder_error: true };
                return;
            }
        })
        return output;
    }
}
